package migrations

import kotlin.Long
import kotlin.String

public data class TemplateTable(
  public val id: String,
  public val name: String,
  public val version: Long?,
  public val publishedDate: String,
  public val numberOfPages: Long?,
  public val numberOfSections: Long?,
  public val numberOfQuestions: Long?,
  public val status: String,
)
